import { GanttTask } from '../../types/gantt.types'
import { Z_CONTEXT_MENU } from '../../constants/zIndex'
// 메모 툴팁 (position:fixed — 마일스톤 z-index 충돌 방지)

export type GanttMemoTooltipProps = {
  visibleMemoId: number | null
  memoTooltipPos: { x: number; y: number; } | null
  tasks: GanttTask[]
}

export function GanttMemoTooltip({ visibleMemoId, memoTooltipPos, tasks }: GanttMemoTooltipProps) {
  return (
    <>
      {visibleMemoId !== null && memoTooltipPos && (() => {
        const memoTask = tasks.find(t => t.taskId === visibleMemoId)
        return memoTask?.description ? (
          <div data-memo-popup style={{
            position: 'fixed', top: memoTooltipPos.y, left: memoTooltipPos.x, zIndex: Z_CONTEXT_MENU,
            background: 'var(--shell-surface)', border: 'var(--border-width-hairline) solid var(--shell-border)', borderRadius: 12,
            padding: '9px 12px', fontSize: 'var(--type-caption-size)', color: 'var(--shell-on-surface)', lineHeight: 1.6,
            whiteSpace: 'pre-wrap', wordBreak: 'break-all',
            boxShadow: 'var(--elevation-2)',
            minWidth: 140, maxWidth: 220,
          }}>
            {memoTask.description}
          </div>
        ) : null
      })()}
    </>
  )
}
